import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";
import { GeneralSettingState } from "models/generalSetting";

const initialState: GeneralSettingState = {
  loading: false,
  data: {},
  message: "",
  success: false,
  smtpdata: {},
  supportUserdata: {},
  generaldata: {},
};

const generalSettingSlice = createSlice({
  name: "generalSetting",
  initialState,
  reducers: {
    getGeneralDetail(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getGeneralDetailSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.generaldata = action.payload;
      state.success = action.payload.success;
    },
    getGeneralDetailFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    getSMTPDetail(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getSMTPDetailSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.smtpdata = action.payload;
      state.success = action.payload.success;
    },
    getSMTPDetailFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    getSupportUserDetail(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getSupportUserDetailSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.supportUserdata = action.payload;
      state.success = action.payload.success;
    },
    getSupportUserDetailFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    addSMTPDetails(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.smtpmessage = "";
    },
    addSMTPDetailsSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.smtpmessage = action.payload.message;
      state.success = action.payload.success;
    },
    addSMTPDetailsFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.smtpmessage = action.payload.message;
      state.success = action.payload.success;
    },
    addSupportUserDetails(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.supportusermessage = "";
    },
    addSupportUserDetailsSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.supportusermessage = action.payload.message;
      state.success = action.payload.success;
    },
    addSupportUserDetailsFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.supportusermessage = action.payload.message;
      state.success = action.payload.success;
    },
    addGeneralDetails(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.generalmessage = "";
    },
    addGeneralDetailsSuccess(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.generalmessage = action.payload.message;
      state.success = action.payload.success;
    },
    addGeneralDetailsFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.generalmessage = action.payload.message;
      state.success = action.payload.success;
    },
    getImageUrl(state, action: PayloadAction<ApiResponse>) {
      state.imgloading = true;
      state.imageUrl = "";
    },
    getImageUrlSuccess(state, action: PayloadAction<ApiResponse>) {
      state.imgloading = false;
      state.imageUrl = action.payload.photoURL;
    },
    getImageUrlFailed(state, action: PayloadAction<ApiResponse>) {
      state.imgloading = false;
      state.imageUrl = "";
    },
    clearData(state) {
      state.loading = false;
      state.message = "";
      state.success = false;
    },
  },
});

export const generalSettingAction = generalSettingSlice.actions;

export const getGeneralData = (state: RootState) =>
  state.generalSetting.generaldata;
export const getSMTPData = (state: RootState) => state.generalSetting.smtpdata;
export const getSupportUserData = (state: RootState) =>
  state.generalSetting.supportUserdata;
export const selectIsLoading = (state: RootState) =>
  state.generalSetting.loading;
export const selectIsSuccess = (state: RootState) =>
  state.generalSetting.success;
export const selectMessage = (state: RootState) => state.generalSetting.message;
export const selectGeneralMessage = (state: RootState) =>
  state.generalSetting.generalmessage;
export const selectSmtpMessage = (state: RootState) =>
  state.generalSetting.smtpmessage;
export const selectSupportuserMessage = (state: RootState) =>
  state.generalSetting.supportusermessage;
export const imageLoading = (state: RootState) =>
  state.generalSetting.imgloading;
export const selectImageUrl = (state: RootState) =>
  state.generalSetting.imageUrl;

const generalSettingReducer = generalSettingSlice.reducer;
export default generalSettingReducer;
